import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import AFDPostcodeResultDetail from '../ViewModels/AFDPostcodeResultDetail';
import AddressDropDownViewModel from '../ViewModels/AddressDropDownViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IAddressDropDownProps {
    setAddress: (newAddress: AFDPostcodeResultDetail, index: number) => void;
    address: number | undefined;
    disabled: boolean;
    model: AFDPostcodeResultDetail[];
}

interface IAddressDropDownState {
    
    loaded: boolean;
    model: AddressDropDownViewModel[];
}

class AddressDropDown extends Component<IAddressDropDownProps & WithStyles<typeof styles>, IAddressDropDownState> {
    constructor(props) {
        super(props);
        //console.log('AddressDropDown ' + 1);
        let newModel: AddressDropDownViewModel[] = [];

        this.props.model.forEach((value, index) => {
            //{console.log(this.props.model)}
            //{console.log(value)}
            let newVal: AddressDropDownViewModel = new AddressDropDownViewModel;
            newVal.display = (value.Organisation !== null && value.Organisation !== undefined ? '' : value.Organisation = ' ') + value.Property + " " + value.Street + ', ' +
                value.Town + ', ' + value.OptionalCounty;
            newVal.index = index;
            newModel.push(newVal);
        });
        //console.log('AddressDropDown ' + 2);
        this.state = {
            loaded: true,
            model: newModel
        }
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        //console.log(1);
        //console.log(this.props);
        //console.log(prevProps);

        if (this.props.model !== prevProps.model) {
            //console.log(2);
            this.setState({ loaded: false }, () => {
                //console.log(3);
                let newModel: AddressDropDownViewModel[] = [];

                this.props.model.forEach((value, index) => {
                    let newVal: AddressDropDownViewModel = new AddressDropDownViewModel;
                    newVal.display = value.Property + " " + value.Street + ', ' +
                        value.Town + ', ' + value.OptionalCounty;
                    newVal.index = index;
                    newModel.push(newVal);
                });

                this.setState({
                    loaded: true,
                    model: newModel
                });
            });
        }
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultAddressVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.index} value={item.index}>{item.display}</MenuItem>
            );
            
        }

        return (
            <TextField
                label="Address"
                name="address"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.address}
                onChange={this.props.disabled ? undefined : this.setAddress}
                disabled={this.props.disabled}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
                
                
            >
                {items}
            </TextField>
        );
    }

    public setAddress = (event) => {
        if (this.props.model[event.target.value] != undefined) {
            this.props.setAddress(this.props.model[event.target.value], event.target.value);
        }
    }
}

export default withStyles(styles)(AddressDropDown);